import {
  messageAttachmentDownloadUrlResponseSchema,
  type MessageAttachmentDownloadUrlRequest,
  type MessageAttachmentDownloadUrlResponse,
} from "@multi-chat/shared";
import { apiGetBlob, apiPost } from "./client.js";

export type CreateMessageAttachmentDownloadUrlOptions = {
  disposition?: MessageAttachmentDownloadUrlRequest["disposition"];
  signal?: AbortSignal;
};

export async function createMessageAttachmentDownloadUrl(
  organizationId: number,
  attachmentId: string,
  options?: CreateMessageAttachmentDownloadUrlOptions,
): Promise<MessageAttachmentDownloadUrlResponse> {
  return messageAttachmentDownloadUrlResponseSchema.parse(
    await apiPost(
      `/organizations/${organizationId}/message-attachments/${attachmentId}/download-url`,
      { disposition: options?.disposition ?? "inline" },
      options?.signal,
    ),
  );
}

export async function fetchMessageAttachmentContentBlob(
  organizationId: number,
  attachmentId: string,
  signal?: AbortSignal,
): Promise<Blob> {
  return apiGetBlob(
    `/organizations/${organizationId}/message-attachments/${attachmentId}/content`,
    signal,
  );
}
